import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import VenueCard, { VenueCardSkeleton } from "@/components/VenueCard";
import { Link } from "react-router-dom";

export default function Highlighted() {
  const [cities, setCities] = useState([]);
  const [byCity, setByCity] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(()=>{
    (async () => {
      const cs = (await api.get("/cities")).data.slice(0, 8);
      setCities(cs);
      const results = {};
      for (const c of cs) {
        const r = await api.get(`/venues/highlighted/${encodeURIComponent(c.name)}`);
        results[c.name] = r.data.slice(0, 3);
      }
      setByCity(results);
      setLoading(false);
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
      <div className="text-[10px] uppercase tracking-widest-2 text-[color:var(--wine)]">Editor's picks</div>
      <h1 className="font-display text-5xl mb-10">Highlighted venues, city by city</h1>
      {loading && <div className="grid md:grid-cols-3 gap-6">{Array.from({length:6}).map((_,i)=><VenueCardSkeleton key={i}/>)}</div>}
      {!loading && cities.map(c=>(
        <section key={c.name} className="mb-14">
          <div className="flex items-end justify-between mb-4">
            <h2 className="font-display text-3xl">{c.name} <span className="text-neutral-400 text-lg">· {c.state}</span></h2>
            <Link to={`/properties?city=${encodeURIComponent(c.name)}`} className="text-sm text-[color:var(--wine)]">Explore all →</Link>
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {(byCity[c.name] || []).map(v=><VenueCard key={v.id} v={v}/>)}
            {!(byCity[c.name] || []).length && <div className="text-neutral-500 text-sm col-span-3">No premium venues yet in {c.name}.</div>}
          </div>
        </section>
      ))}
    </div>
  );
}
